var constants = require('../constants');
var api = require('../../../utils/api');
var routerActions = require('react-router-redux').routerActions;
var contactUtils = require('../contactUtils');
var commonActions = require('../../common/actions/common');

var contactActions = (function(){

    var _sendContactRequest = function() {
        return {
            type: constants.CONTACT_SEND_REQUEST
        };
    }

    var _sendContactFailure = function(error) {
        return {
            type: constants.CONTACT_SEND_FAILURE,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: constants.CONTACT_SEND_FAILURE,
                    actionValue: 'response',
                    labelValue: 'failure'
                }
            }
        };
    }

    var _validateContactFailure = function(error) {
        return {
            type: constants.CONTACT_VALIDATE_FAILURE,
            errors: error
        };
    }

    var _clearContactError = function() {
        return {
            type: constants.CONTACT_CLEAR_ERROR
        };
    }

    var _sendContact = function(email, subject, message) {
        return function(dispatch) {
            contactUtils.validate(email, subject, message)
                .then(function(result) {
                    if (result === true) {

                        dispatch(_sendContactRequest());

                        api.post('/emailproxy', {
                            "email": email,
                            "subject": subject,
                            "message": message
                        }).then(function(data) {
                            dispatch(routerActions.push('/contact/success'));
                        })
                        .catch(function(error) {
                            if(error.response){
                                dispatch(_sendContactFailure(error.response));
                            }else{
                                dispatch(commonActions.setGenericError('', error.message));
                            }
                        })
                    } else {
                        dispatch(_validateContactFailure(result));
                    }
                })
        };
    }

    return {
        sendContact: _sendContact,
        clearContactError: _clearContactError
    }
})();

module.exports = contactActions;



// WEBPACK FOOTER //
// ./src/common/modules/contact/actions/contact.js